import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import {  GetLogIntegracaoResponse } from '../../responses/integracao/get-log-integracao.response';
import { ListaLogIntegracaoResponse } from '../../responses/integracao/lista-log-integracao.response';

@Injectable({
  providedIn: 'root',
})
export class LogIntegracaoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller ChaveAcesso, ajustada para o ambiente de integração.
  private readonly apiUrl = `${environment.urlApiIntegracao}LogIntegracao`;

  /**
   * Lista as chaves de acesso com base em filtros opcionais.
   * Corresponde a: [HttpGet] /ChaveAcesso
   * @param textoBusca Filtra pelo nome ou descrição da chave.
   */
  public getLogs(idUri: number, idTipoLog: number, dataInicioRequest: string, pageIndex: number, searchText: string): Observable<ListaLogIntegracaoResponse> {
    let params = new HttpParams();

    if (idUri) {
      params = params.append('idUri', idUri);
    }
    if (idTipoLog) {
      params = params.append('idTipoLog', idTipoLog);
    }
    if (dataInicioRequest) {
      params = params.append('dataInicioRequest', dataInicioRequest);
    }
    if (pageIndex) {
      params = params.append('pageIndex', pageIndex);
    }
    if (searchText) {
      params = params.append('searchText', searchText);
    }
 
    return this.httpClient
      .get<ListaLogIntegracaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  /**
   * Busca os dados de uma única chave de acesso pelo seu ID.
   * Corresponde a: [HttpGet] /ChaveAcesso/idIntegrationLog/{idIntegrationLog}
   * @param idIntegrationLog O ID da chave de acesso.
   */
  public getLogPorId(idIntegrationLog: number): Observable<GetLogIntegracaoResponse> {
    const url = `${this.apiUrl}/idIntegrationLog/${idIntegrationLog}`;
    return this.httpClient
      .get<GetLogIntegracaoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}